<template>
  <div class="flex h-full min-h-0 flex-col">
    <div class="mb-2 flex items-baseline justify-between">
      <div class="breadcrumbs text-primary text-base font-bold">
        <ul>
          <li>
            <RouterLink :to="{ name: 'ClientList' }">Danh sách máy trạm</RouterLink>
          </li>
          <li>
            <RouterLink :to="{ name: 'ClientInfo' }">
              {{ client_detail_store.client_detail?.computer_name }}
            </RouterLink>
          </li>
          <template v-for="t in client_detail_store.tabs" :key="t.route_name">
            <li v-if="$route.matched.some((r) => r.name === t.route_name)">
              <RouterLink :to="{ name: t.route_name, params: t.route_params }">
                {{ t.value }}
              </RouterLink>
            </li>
          </template>
          <li v-if="$route.params.action_id">{{ $route.params.action_id }}</li>
        </ul>
      </div>
    </div>
    <div
      v-if="client_detail_store.client_detail?.uninstalled"
      role="alert"
      class="alert alert-warning mb-4"
    >
      <i class="fa-solid fa-triangle-exclamation"></i>
      <span>Máy trạm này đã được gỡ cài đặt</span>
    </div>

    <ClientDetailNavigation :active="active_section" @select="navigate_section" />

    <main id="client-detail-content" role="tabpanel" :aria-labelledby="`client-section-${active_section}`" class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
      <div class="border-base-200 bg-base-100 flex min-h-0 flex-1 flex-col overflow-auto border p-4 shadow-sm">
        <RouterView />
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { use_client_detail } from "@/components/ClientDetail/useClientDetail";
import ClientDetailNavigation, { type ClientDetailSection } from "@/components/ClientDetail/ClientDetailNavigation/ClientDetailNavigation.vue";
import { clientFunctionCategories } from "@/components/ClientDetail/ClientDetailNavigation/functionCategories";
import { computed } from "vue";
import { RouterLink, RouterView, useRoute, useRouter } from "vue-router";

const client_detail_store = use_client_detail();
const route = useRoute();
const router = useRouter();
const active_section = computed<ClientDetailSection>(() => {
  const names = route.matched.map((record) => record.name);
  if (names.includes("ClientFunctions")) {
    return clientFunctionCategories.find((category) => category.id === route.query.category)?.id ?? "system";
  }
  return clientFunctionCategories.find((category) => category.routes.some((name) => names.some((matched) => String(matched).startsWith(name))))?.id ?? "system";
});

function navigate_section(section: ClientDetailSection) {
  // A category with a single destination is that destination, not a one-item list.
  const routes = clientFunctionCategories.find((category) => category.id === section)?.routes ?? [];
  if (routes.length === 1) {
    router.push({ name: routes[0]!, params: { client_id: route.params.client_id } });
    return;
  }
  router.push({ name: "ClientFunctions", params: { client_id: route.params.client_id }, query: { category: section } });
}
</script>
